import {needAuth} from "../instance/Instance";
import {AxiosError} from "axios";

const grantApproval = (data) => {
    try {
        return needAuth.post(`/contentApprovalGroups/grant`, data);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

export { grantApproval };